import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=4f850520&scoped=true"
import script from "./BoxList.vue?vue&type=script&lang=js"
export * from "./BoxList.vue?vue&type=script&lang=js"
import style0 from "./BoxList.vue?vue&type=style&index=0&id=4f850520&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f850520",
  null
  
)

export default component.exports